/**
 * Узбекский словарь интерфейса.
 *
 * Ключи обязаны совпадать с русским словарём — за этим следит тип
 * `Record<Key, string>`: пропущенный перевод не пройдёт компиляцию.
 */
import type { Key } from './ru';

export const uz: Record<Key, string> = {
  appName: 'Arbuz',
  tagline: 'Toshkent boʻylab poliz mahsulotlari yetkazib berish',
  welcomeTitle: 'Sersuv tarvuz\nyetkazib beramiz!',
  welcomeText: 'Yangi va shirin tarvuzlar toʻgʻri uyingizgacha',
  orderWatermelon: 'Tarvuz buyurtma qilish',
  howWorks: 'Bu qanday ishlaydi?',
  setupTitle: 'Profilni sozlash',
  setupHeading: 'Tarvuzni qayerga olib boramiz?',
  setupText: 'Kuryer bogʻlana olishi uchun telefon va manzilni qoʻshing.',
  phoneTitle: 'Telefon raqami',
  phoneTelegramOnly: 'Telegram orqali, qoʻlda kiritmasdan',
  addressSetupHint: 'Nuqta va manzil tafsilotlarini kiriting',
  continueOrder: 'Saqlash va davom etish',
  homeHeroTitle: 'Yangi tarvuzni yetkazib berish bilan buyurtma qiling',
  homeHeroText: 'Pishgan tarvuzni toʻgʻri uyingizgacha olib boramiz',
  homeBenefits: 'Buyurtma afzalliklari',
  benefitQuality: 'Saralangan tarvuzlar',
  benefitQualityText: 'Faqat pishgan va shirin',
  benefitDelivery: 'Tez yetkazish',
  benefitDeliveryText: 'Sizga qulay vaqtda',
  benefitOrder: 'Qulay buyurtma',
  benefitOrderText: 'Manzil, vaqt va miqdor',
  benefitContact: 'Yetkazishgacha aloqadamiz',
  benefitContactText: 'Manzil va vaqtni aniqlaymiz',
  selectWatermelonTitle: 'Tarvuzni tanlang',
  selectWatermelonText: 'Manzilingiz uchun mavjud takliflarni ko‘rsatamiz.',
  availableForAddress: 'Manzil uchun mavjud',
  deliveryArea: 'Ijrochi va yetkazish',
  selectBeforeCheckout: 'Tarvuzni tanlang',
  catalogHome: 'Bosh sahifa',
  favorites: 'Sevimlilar',
  quantityTitle: 'Tarvuzlar soni',
  productUnavailable: 'Mahsulot endi sotilmaydi. Bosh sahifaga qaytib, mavjud mahsulotni tanlang.',
  approxWeightOne: 'Bittasining oʻrtacha vazni',
  totalApprox: 'Taxminan jami',
  totalToPay: 'Toʻlov jami',
  paymentConfirmTitle: 'Buyurtmani tasdiqlang',
  payOnDelivery: 'Qabul qilishda toʻlanadi',
  paymentCashShort: 'Naqd pul',
  paymentCardShort: 'Kartaga oʻtkazma',
  deliveryIncluded: 'yetkazish kiritilgan',
  deliveryContactTitle: 'Yetkazishdan oldin bogʻlanamiz',
  deliveryContactText: 'Manzilni tekshiramiz va tanlangan vaqtda olib boramiz',
  catalog: 'Katalog',
  orders: 'Buyurtmalar',
  profile: 'Profil',
  checkout: 'Buyurtma berish',
  total: 'Jami',
  sum: 'soʻm',
  kg: 'kg',
  approxWeight: 'Taxminiy vazn',
  emptyCatalog: 'Katalog hozircha boʻsh',
  emptyCatalogHint: 'Mahsulotlar tez orada paydo boʻladi.',
  goToCatalog: 'Katalogga oʻtish',
  loadError: 'Katalogni yuklab boʻlmadi',
  retry: 'Qayta urinish',
  needPhoneTitle: 'Telefon raqami kerak',
  soon: 'Buyurtma berish keyingi bosqichda paydo boʻladi.',
  sizeS: 'Kichik',
  sizeM: 'Oʻrtacha',
  sizeL: 'Katta',
  decrease: 'Sonini kamaytirish',
  increase: 'Sonini oshirish',
  addressTitle: 'Yetkazib berish manzili',
  useMyLocation: '📍 Mening joylashuvim',
  pickOnMap: 'Xaritada koʻrsatish',
  hideMap: 'Xaritani yashirish',
  mapLoading: 'Xarita yuklanmoqda…',
  pointNotSet: 'Nuqta koʻrsatilmagan. Joylashuvni yuboring yoki xaritada belgilang.',
  checkingZone: 'Hudud aniqlanmoqda…',
  deliveryPrice: 'Yetkazib berish',
  outOfZone: 'Bu manzilga yetkazib berish hozircha mavjud emas',
  streetLabel: 'Koʻcha va tuman',
  houseLabel: 'Uy',
  apartmentLabel: 'Xonadon',
  entranceLabel: 'Kirish',
  floorLabel: 'Qavat',
  landmarkLabel: 'Moʻljal (ixtiyoriy)',
  saveAddress: 'Manzilni saqlash',
  saving: 'Saqlanmoqda…',
  addressSaved: 'Manzil saqlandi',
  changeAddress: 'Manzilni oʻzgartirish',
  slotTitle: 'Yetkazib berish vaqti',
  checkComposition: 'Tarkibni tekshiring',
  confirmTitle: 'Buyurtmangizni tekshiring',
  confirmOrder: 'Buyurtmani tasdiqlash',
  next: 'Keyingi',
  pcs: 'dona',
  commentLabel: 'Izoh (ixtiyoriy)',
  commentPlaceholder: 'Masalan: juda shirin boʻlsin',
  paymentTitle: 'Toʻlov usuli',
  paymentCash: 'Qabul qilishda naqd pul',
  paymentCard: 'Kartaga oʻtkazma',
  noAddressYet: 'Sizda hali saqlangan manzil yoʻq.',
  addAddress: 'Manzil qoʻshish',
  orderAccepted: 'Buyurtma qabul qilindi!',
  orderAcceptedText: 'Rahmat! Biz siz bilan bogʻlanamiz va koʻrsatilgan vaqtda yetkazamiz.',
  orderNumber: 'Buyurtma raqami',
  toMyOrders: 'Buyurtmalarimga oʻtish',
  toHome: 'Bosh sahifaga',
  slotReason_full: 'Bu vaqt band',
  slotReason_lead_time: 'Yetkazish vaqtiga juda yaqin',
  slotReason_closed: 'Bu kuni yetkazmaymiz',
  slotReason_past: 'Vaqt oʻtib ketdi',
  activeOrders: 'Faol',
  completedOrders: 'Yakunlangan',
  noOrders: 'Hozircha buyurtma yoʻq',
  cancelOrder: 'Buyurtmani bekor qilish',

  // ── Курьер ────────────────────────────────────────────────────────────
  courierDeliveries: 'Mening yetkazmalarim',
  courierProfile: 'Profil',
  courierNoActive: 'Biriktirilgan yetkazma yoʻq',
  courierNoActiveHint: 'Yangi buyurtma shu chatga xabar boʻlib keladi.',
  courierNoCompleted: 'Yakunlangan yetkazmalar hozircha yoʻq',
  courierOrder: 'Buyurtma',
  clientLabel: 'Mijoz',
  addressLabel: 'Manzil',
  callClient: 'Qoʻngʻiroq qilish',
  openMap: 'Xaritada ochish',
  toCollect: 'Toʻlovga',
  markAssembled: 'Buyurtma yigʻildi',
  markOnTheWay: 'Mijoz tomon yoʻlga chiqdim',
  markDelivered: 'Buyurtmani topshirish',
  markFailed: 'Yetkazib boʻlmadi',
  deliverTitle: 'Buyurtmani topshirish',
  collectedLabel: 'Qabul qilingan summa',
  collectedHint: 'Summa jamidan farq qilsa — tuzating, tafovutni administrator koʻradi.',
  confirmDelivery: 'Topshirishni tasdiqlash',
  failTitle: 'Yetkazib berish amalga oshmadi',
  failReasonLabel: 'Nima boʻldi',
  failCommentLabel: 'Tafsilotlar (ixtiyoriy)',
  confirmFail: 'Yetkazilmagan deb belgilash',
  failReason_no_answer: 'Mijoz javob bermayapti',
  failReason_wrong_address: 'Manzil notoʻgʻri koʻrsatilgan',
  failReason_client_refused: 'Mijoz rad etdi',
  failReason_unreachable: 'Manzilga yetib boʻlmadi',
  failReason_other: 'Boshqa sabab',
  pickupTitle: 'Yigʻish nuqtasi',
  pickupHint: 'Buyurtmalarni shu yerdan olasiz. Nuqtani administrator koʻradi va marshrut rejalashtirishda asqotadi.',
  pickupAddressLabel: 'Yigʻish nuqtasi manzili',
  pickupNotSet: 'Yigʻish nuqtasi belgilanmagan',
  savePickup: 'Yigʻish nuqtasini saqlash',
  pickupSaved: 'Yigʻish nuqtasi saqlandi',
  clearPickup: 'Nuqtani olib tashlash',
  languageLabel: 'Til',
  actionFailed: 'Amalni bajarib boʻlmadi',
  networkError: 'Server bilan aloqa yoʻq',
  ordersLoadError: 'Yetkazmalarni yuklab boʻlmadi',
  amountInvalid: 'Summani raqam bilan kiriting',
  courierHome: 'Asosiy',
  executorLabel: 'Ijrochi',
  nextOrder: 'Eng yaqin',
  openOrder: 'Ochish',
  vendorStatus: 'Doʻkon',
  vendorWorking: 'Ishlayapti',
  readiness: 'Tayyorlik',
  readyOf: 'dan',
  quickActions: 'Tezkor amallar',
  currentOrders: 'Joriy buyurtmalar',
  currentOrdersHint: 'Ishda',
  productPriceAvailability: 'Narx va mavjudlik',
  zoneMapDelivery: 'Xarita va yetkazish',
  profileContactPayment: 'Aloqa va toʻlov',
  ordersInWork: 'Ishda',
  orderHistory: 'Tarix',
  executorProfile: 'Ijrochi profili',
  profileSettings: 'Sozlamalar',
  deliveries: 'yetkazma',

  // ── Кабинет исполнителя ───────────────────────────────────────────────
  shopTitle: 'Mening doʻkonim',
  shopOpen: 'Buyurtma qabul qilaman',
  shopClosed: 'Buyurtma qabul qilmayman',
  shopOpenHint: 'Doʻkon oʻchiq ekan, mijozlar sizni koʻrmaydi.',
  shopChecklist: 'Boshlash uchun nima kerak',
  shopNeedProducts: 'Kamida bitta mahsulot qoʻshing',
  shopNeedZones: 'Yetkazib berish hududini belgilang',
  shopNeedSchedule: 'Ish kunlarini belgilang',
  shopReady: 'Hammasi tayyor — doʻkonni yoqsa boʻladi',
  shopSectionProducts: 'Mahsulotlar',
  shopSectionZones: 'Yetkazib berish hududi',
  shopSectionSchedule: 'Ish vaqti',
  shopSectionPayout: 'Aloqa va toʻlov',
  shopNameLabel: 'Doʻkon nomi',
  shopNameHint: 'Mijoz ijrochini tanlashda sizni shunday koʻradi.',
  shopCapacityLabel: 'Bitta vaqt oraligʻidagi buyurtmalar',
  shopCapacityHint: 'Bitta vaqt oraligʻida nechta yetkazmani ulgurasiz.',
  shopNone: 'Doʻkon hali ochilmagan',
  shopNoneHint: 'Administratorga murojaat qiling — u sizga doʻkon ochib beradi.',
  shopLoadError: 'Doʻkonni yuklab boʻlmadi',
  shopSaved: 'Saqlandi',

  // Товары
  loading: 'Yuklanmoqda…',
  vendorsTitle: 'Kim yetkazadi',
  vendorsText: 'Sizning manzilingizga yetkazadiganlarni koʻrsatamiz.',
  vendorsEmpty: 'Bu manzilga hozircha hech kim yetkazmaydi',
  vendorsEmptyHint: 'Boshqa manzilni kiriting — biz butun shahar boʻylab ishlamaymiz.',
  vendorsEmptyPointHint:
    'Yetkazib berish manzil nomi boʻyicha emas, xaritadagi nuqta boʻyicha aniqlanadi. Nuqta notoʻgʻri tursa — uni toʻgʻrilang.',
  vendorsAllClosed: 'Bugun hammasi yopiq',
  vendorsAllClosedHint: 'Buyurtmani boshqa kunga berish mumkin.',
  vendorsLoadError: 'Ijrochilar roʻyxatini yuklab boʻlmadi',
  vendorFrom: 'dan',
  vendorWorksToday: 'bugun',
  vendorClosedToday: 'bugun ishlamaydi',
  vendorChange: 'Ijrochini almashtirish',
  vendorSwitchConfirm: 'Savatda boshqa ijrochining mahsuloti bor. Savat tozalansinmi?',
  vendorLabel: 'Ijrochi',
  vendorGone: 'Bu ijrochi endi sizning manzilingizga yetkazmaydi. Boshqasini tanlang.',
  cardTransferTitle: 'Oʻtkazma uchun rekvizitlar',
  cardTransferHint: 'Summani kartaga oʻtkazing va yetkazishda ijrochiga ayting.',
  cardTransferMissing: 'Rekvizitlar hali koʻrsatilmagan — naqd toʻlovni tanlang.',
  back: 'Orqaga',
  productsCount: 'mahsulot',
  zonesCount: 'hudud',
  productsEmpty: 'Mahsulotlar hozircha yoʻq',
  productsEmptyHint: 'Sotadigan narsangizni qoʻshing: turi, narxi va surati.',
  productsLoadError: 'Mahsulotlarni yuklab boʻlmadi',
  productAdd: 'Mahsulot qoʻshish',
  productEditTitle: 'Mahsulot',
  productTypeLabel: 'Nima sotasiz',
  productTypeHint: 'Mahsulot nomini mijoz turiga qarab koʻradi — oʻzingiz yozishingiz shart emas.',
  productTypesError: 'Mahsulot turlarini yuklab boʻlmadi',
  productPriceLabel: 'Dona narxi, soʻm',
  productSizeLabel: 'Oʻlchami',
  productSizeNone: 'Koʻrsatilmagan',
  productSizeS: 'Kichik',
  productSizeM: 'Oʻrtacha',
  productSizeL: 'Katta',
  productWeightLabel: 'Vazni, kg',
  productWeightFrom: 'dan',
  productWeightTo: 'gacha',
  productDescriptionLabel: 'Tavsif',
  productAvailable: 'Sotuvda',
  productPhoto: 'Surat',
  productPhotoAdd: 'Surat olish yoki tanlash',
  productPhotoUploading: 'Surat yuklanmoqda…',
  productPhotoError: 'Suratni yuklab boʻlmadi',
  productSave: 'Mahsulotni saqlash',
  productRemove: 'Sotuvdan olish',
  productRemoveConfirm: 'Mahsulot sotuvdan olinsinmi? Mijozlar uni koʻrmay qoladi.',
  productHidden: 'Sotuvdan olingan',

  // Зоны
  zonesEmpty: 'Yetkazib berish hududi belgilanmagan',
  zonesEmptyHint: 'Xaritada boradigan hududingizni chizing va yetkazish narxini koʻrsating.',
  zonesLoadError: 'Hududlarni yuklab boʻlmadi',
  zoneAdd: 'Hudud qoʻshish',
  zoneEditTitle: 'Yetkazib berish hududi',
  zoneNameLabel: 'Hudud nomi',
  zoneNameHint: 'Oʻzingiz uchun, mijozga koʻrsatilmaydi.',
  zonePriceLabel: 'Yetkazish narxi, soʻm',
  zoneActive: 'Hudud ishlaydi',
  zonePoints: 'ta nuqta',
  zoneAreaUnit: 'km²',
  zoneSave: 'Hududni saqlash',
  zoneRemove: 'Hududni oʻchirish',
  zoneRemoveConfirm: 'Hudud oʻchirilsinmi? Mijozlar bu manzillarda sizni koʻrmay qoladi.',
  zoneNeedPoints: 'Hududni chizing: kamida uchta nuqta kerak',
  zoneHasOrders: 'Bu hudud boʻyicha buyurtmalar boʻlgan — uni oʻchirib emas, faqat toʻxtatib qoʻysa boʻladi',
  zoneMapTitle: 'Hudud chizmasi',
  zoneMapOpen: 'Xaritada oʻzgartirish',
  zoneMapDraw: 'Hududni xaritada chizish',
  zonePreviewEmpty: 'Hudud hali chizilmagan',
  zonePreviewHint: 'Yetkazib beradigan hududingizni barmoq bilan chizing: xarita butun ekranga ochiladi.',
  zoneMapDone: 'Tayyor',
  zoneMapCancel: 'Bekor qilish',
  zoneMapDiscard: 'Xarita yopilsinmi? Chizmadagi oʻzgarishlar saqlanmaydi.',
  zoneMapToolDraw: 'Chizish',
  zoneMapToolPoints: 'Nuqtalar',
  zoneMapNoToolHint: 'Xaritani surish va masshtablash mumkin. Chizish uchun asbobni tanlang.',
  zoneMapDrawHint: 'Yetkazib berish hududini barmogʻingiz bilan qalamdek chizib chiqing.',
  zoneMapPointsHint: 'Nuqta qoʻyish uchun xaritani bosing. Nuqtani bossangiz, u oʻchadi.',
  zoneMapUndo: 'Bekor qilish',
  zoneMapPoints: 'Nuqtalar',
  zoneMapNeedMore: 'kamida 3 ta kerak',
  zoneMapCrossing: 'Chiziqlar kesishmoqda — nuqtalarni toʻgʻrilang',
  zoneMapReset: 'Tozalash',
  zoneMapResetConfirm: 'Chizma butunlay olib tashlansinmi?',
  zoneMapAria: 'Yetkazib berish hududini tahrirlash xaritasi',
  zoneCheaperHint: 'Bir nechta hudud ustma-ust tushsa, mijozga arzonrogʻi hisoblanadi.',

  // Расписание
  scheduleTitle: 'Ish vaqti',
  scheduleHint: 'Mijoz faqat siz ishlaydigan vaqtlarni koʻradi.',
  scheduleDayOff: 'Dam olish kuni',
  scheduleFrom: 'dan',
  scheduleTo: 'gacha',
  scheduleSave: 'Jadvalni saqlash',
  scheduleSaved: 'Jadval saqlandi',
  scheduleAllClosed: 'Kamida bitta ish kunini belgilang',
  scheduleBadHours: 'Kun boshi tugashidan oldin boʻlishi kerak',
  weekday_0: 'Yakshanba',
  weekday_1: 'Dushanba',
  weekday_2: 'Seshanba',
  weekday_3: 'Chorshanba',
  weekday_4: 'Payshanba',
  weekday_5: 'Juma',
  weekday_6: 'Shanba',
  daysOffTitle: 'Dam olish kunlari',
  daysOffHint: 'Ishlamaydigan alohida sanalar.',
  daysOffEmpty: 'Dam olish kunlari belgilanmagan',
  daysOffAdd: 'Dam olish kuni qoʻshish',
  daysOffRemove: 'Olib tashlash',

  // Связь и выплаты
  payoutTitle: 'Aloqa va toʻlov',
  payoutPhoneLabel: 'Aloqa uchun telefon',
  payoutPhoneHint: 'Shu raqam orqali mijoz yoki administrator siz bilan bogʻlanadi.',
  payoutPhoneInvalid: 'Format: +998XXXXXXXXX',
  payoutCardLabel: 'Toʻlov uchun karta',
  payoutCardHint: 'Platforma siz bilan shu karta orqali hisoblashadi. Mijozga koʻrsatilmaydi: u sizga naqd toʻlaydi.',
  payoutCardInvalid: 'Karta raqami — 16 ta raqam',
  payoutHolderLabel: 'Karta egasi',
  payoutSave: 'Saqlash',

  // Подтверждение заказа исполнителем
  orderConfirm: 'Buyurtmani qabul qilish',
  orderConfirmByAdmin: 'Buyurtmani administrator tasdiqlaydi',

  // ── Статусы заказа ────────────────────────────────────────────────────
  status_new: 'Qabul qilindi, tasdiq kutilmoqda',
  status_confirmed: 'Tasdiqlandi',
  status_assembled: 'Yigʻildi',
  status_on_the_way: 'Kuryer yoʻlda',
  status_delivered: 'Yetkazildi',
  status_cancelled: 'Bekor qilindi',
  status_failed: 'Yetkazilmadi',

  // ── Отправка телефона в приложении ──────────────────────────────────────
  sharePhoneButton: '📱 Raqamni yuborish',
  sharePhoneChecking: 'Tekshirilmoqda…',
  sharePhoneRetry: 'Yana tekshirish',
  sharePhoneDeclined: 'Raqam yuborilmadi. Istalgan vaqtda qayta urinib koʻrishingiz mumkin.',
  sharePhoneUnsupported: 'Raqamni shu yerdan yuborish uchun Telegram-ni yangilang.',

  // ── Ошибки геолокации внутри мини-аппа ──────────────────────────────────
  locationDenied: 'Joylashuvga ruxsat berilmagan.',
  openLocationSettings: 'Sozlamalarni ochish',
  retryLocation: 'Qayta urinish',
  locationUnsupported: 'Telegram versiyangiz avtomatik aniqlashni qoʻllab-quvvatlamaydi — xaritada belgilang.',
  locationError: 'Joylashuvni aniqlab boʻlmadi.',
  sendLocationViaBot: 'Bot orqali joylashuv yuborish',
  lastLocationBanner: 'Botdan joylashuvingizni oldik — ishlataylikmi?',
  lastLocationUse: 'Shu nuqtadan foydalanish',
  dismiss: 'Hozir kerak emas',
};
